var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 201,
    viewBox: "0 0 361 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0685425,
    y: 0.987305,
    width: 360,
    height: 200,
    rx: 16,
    fill: "#C9E3D7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.145 0.987305L221.97 76.9669L182.067 0.987305H209.037L222.795 27.1919L237.688 0.987305H265.145Z",
    fill: "#8CC4A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.069 0.987305L303.435 9.93426C295.735 14.0499 289.279 20.3326 284.743 28.1264L220.597 140.987L161.445 28.3451C157.197 20.2332 150.721 13.5727 142.692 9.08927L128.069 0.987305H170.856C175.512 5.79878 179.461 11.2664 182.595 17.2708L221.432 91.2124L264.07 16.1872C267.333 10.5605 271.283 5.46078 275.819 0.987305H320.069Z",
    fill: "#8CC4A9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeach);
export default __webpack_public_path__ + "static/media/peach.9089770eff360318f104a891b1646414.svg";
export { ForwardRef as ReactComponent };